import React, { useEffect, useState } from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";
// import {useForm} from "react-hook-form";
import applicationComander from "../../../store/commanders/application.comander";
import { useSelector } from "react-redux";

import {
  Box,
  Button,
  Divider,
  Group,
  PasswordInput,
  Space,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { validateEmail } from "../../../helpers/form.validators";
import { URL_PATHS } from "../../../consts/url.paths.consts";
import { GoogleButton } from "../../../components/google/google.button";
import { useTranslation } from "react-i18next";
// import LoginRightMessage from "./login.right.message";

export default function LoginPage() {
  const { t } = useTranslation();
  const appState = useSelector((state: any) => state.application);
  const existingUser = useSelector((state: any) => state.account.userData);
  const history = useHistory();
  const location = useLocation<any>();

  const [submitting, setSubmitting] = useState(false);
  const onSubmit = async (data) => {
    if (submitting) return;
    setSubmitting(true);
    try { await applicationComander.cmd_login(data.email.trim().toLowerCase(), data.password); }
    finally { setSubmitting(false); }
  };

  const form = useForm({
    initialValues: {
      email: (location.state as any)?.email || "",
      password: "",
    },

    validate: {
      email: validateEmail,
    },
  });

  useEffect(() => {
    if (existingUser && existingUser.username) {
      form.setValues({ email: existingUser.email });
    }
  }, [existingUser?.username]);


  if (!appState.authorise) {
    // if (!appState.loading && !process.env.REACT_APP_LOCAL) {
    //   window.location.href = process.env.REACT_APP_AUTH_URL;
    //   return <LoaderComponent loading overlayLoading={false}></LoaderComponent>;
    // }
    return (
      <div>
        <div className="auth-container-box">
          <div className="auth-split-layout">
            {/* Left side - Login Form */}
            <Box className="auth-form-section">
              <Title order={1} align={"center"} className="auth-title">
                {t("login.title")}
              </Title>
              <Space h={"xl"}></Space>
              {process.env.REACT_APP_AUTH_MODE === "cognito" && <>
                <GoogleButton
                  text={t("login.google")}
                  onClick={() => {
                    applicationComander.cmd_login_google();
                  }}
                />
                <Divider
                  label={t("login.emailDivider")}
                  labelPosition="center"
                  my="lg"
                />
              </>}
              <Space h="xl" />
              <form
                onSubmit={form.onSubmit((values) => onSubmit(values))}
                className="u-w-100"
              >
                <TextInput
                  required
                  type="email"
                  autoComplete="email"
                  label={t("login.email")}
                  placeholder={t("login.emailPlaceholder")}
                  className="u-w-100"
                  {...form.getInputProps("email")}
                />
                <Space h="md" />
                <PasswordInput
                  required
                  autoComplete="current-password"
                  label={t("login.password")}
                  placeholder={t("login.passwordPlaceholder")}
                  className="u-w-100"
                  {...form.getInputProps("password")}
                />
                <Space h="xs" />
                <div>
                  <Text
                    component="button"
                    type="button"
                    size="sm"
                    align="right"
                    className="auth-link"
                    onClick={() =>
                      history.push(URL_PATHS.FORGOT_PASSWORD, { email: form.values.email })
                    }
                  >
                    {t("login.forgotPassword")}
                  </Text>
                </div>
                <Group mt="lg" mb="sm">
                  <Button
                    size="lg"
                    type="submit"
                    loading={submitting}
                    className="u-w-100 auth-submit-button"
                  >
                    {t("login.submit")}
                  </Button>
                  <Button
                    size="lg"
                    variant="outline"
                    className="u-w-100 mobile-auth-button"
                    onClick={() => history.push(URL_PATHS.SIGNUP)}
                  >
                    {t("login.signUp")}
                  </Button>
                  <Space h={"sm"}></Space>
                </Group>
              </form>
            </Box>

            {/* Right side - Sign Up Prompt */}
            <Box className="auth-prompt-section">
              <div className="auth-prompt-content">
                <Text className="auth-prompt-title">{t("login.createAccount")}</Text>
                <Text className="auth-prompt-description">
                  {t("login.createAccountDescription")}
                </Text>
                <Button
                  variant="outline"
                  size="lg"
                  className="auth-prompt-button"
                  onClick={() => history.push(URL_PATHS.SIGNUP)}
                >
                  {t("login.signUp")}
                </Button>
              </div>
            </Box>
          </div>
        </div>
      </div>
    );
  } else {
    return <Redirect to={URL_PATHS.APP} />;
  }
}
